<template>
  <div v-if="visible" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
    <div class="bg-white rounded-lg shadow-lg w-[90%] max-w-md p-6">
      <h2 class="text-lg font-bold mb-4">Добавить продукцию</h2>

      <form @submit.prevent="addProduct">
        <div class="mb-4">
          <label class="block text-sm font-medium text-gray-700 mb-1">Название продукции</label>
          <input
            type="text"
            v-model="form.name"
            class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Введите название продукции"
          />
        </div>

        <div class="flex justify-end space-x-2">
          <button
            type="button"
            @click="closeModal"
            class="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-500"
          >
            Отмена
          </button>
          <button
            type="submit"
            class="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            Добавить
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      form: {
        name: '', // Название продукции
      },
    };
  },
  methods: {
    addProduct() {
      if (!this.form.name) {
        console.error('Название продукции не может быть пустым');
        return;
      }
      axios
        .post('/api/product/createOrUpdateProduct', {
          name: this.form.name,
        })
        .then(() => {
          this.visible = false; // Закрываем модальное окно
          this.resetForm(); // Очищаем форму
          this.$emit('product-added'); // Уведомляем родителя о добавлении
        })
        .catch((error) => {
          console.error('Ошибка при добавлении продукции:', error);
        });
    },
    resetForm() {
      this.form = {
        name: '',
      };
    },
    closeModal() {
      this.visible = false;
    },
    show() {
      this.visible = true;
    },
  },
};
</script>
